<template>
  <div class="pc-account-wrap">
    <div class="pc-account-card" :class="type">
      <template v-if="type==='loading'">
        <!--        <icu-icon class="pc-big-loader"></icu-icon>-->
      </template>
      <template v-else>
        <template v-if="['inactive'].includes(type)">
          <div class="pc-account-card__in-process">
            <icu-icon class="pc-clock" />
          </div>
        </template>
        <div class="pc-account__iban">
          {{ accountData.iban }}
        </div>
        <div class="pc-account__bank">
          {{ accountData.bank }}
        </div>
        <div class="pc-currencies">
          <div v-for="currency in currencies" :key="currency" class="pc-currency">
            <icu-icon :class="'pc-' + $options.currencies[currency].symbol"></icu-icon>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import IcuIcon from '@/components/common/IcuIcon.vue'

export default {
  name: 'PcPayoutAccount',
  components: {IcuIcon},
  currencies: {
    '1': {
      name: 'pc.accounts.uah',
      symbol: 'uah'
    },
    '2': {
      name: 'pc.accounts.usd',
      symbol: 'usd'
    },
    '3': {
      name: 'pc.accounts.eur',
      symbol: 'eur'
    }
  },
  props: {
    type: {
      type: String,
      default: ''
    },
    accountData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
    }
  },
  computed: {
    currencies() {
      return [...this.accountData.currency].sort()
    },
  }
}
</script>
<style scoped lang="scss">
@import "~@/assets/scss/theme.scss";
.pc-account-wrap {
  padding: 24px;
}



.pc-account-card {
  position: relative;
  width: 370px;
  height: 120px;
  padding: 16px;
  box-shadow: 0px 5px 9px 0px #4A495926;
  border-radius: 10px;
  background: url('~@/assets/img/pc/сard_red.jpg');

  &__in-process {
    position: absolute;
    right: 10px;
    top: 10px;
  }

  &.inactive {
    background: url('~@/assets/img/pc/сard_gray.jpg');
  }

  &.loading {
    background-image:
    url('~@/assets/img/pc/pc-card-placeholder2.svg'),
    url('~@/assets/img/pc/pc-card-placeholder4.svg'),
    url('~@/assets/img/pc/сard_red.jpg');
    background-repeat: no-repeat, no-repeat, no-repeat, no-repeat;
    background-position: 5% 80%, 5% 15%, center;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__in-process {
    position: absolute;
    right: 0;
    font-size: 14px;
    color: $gray;
    display: flex;
    align-items: center;
    .pc-clock {
      margin-right: 8px;
    }
  }

  * {
    color: $white;
  }
  .pc-account__iban {
    text-shadow: 0px 4px 4px #14141459;

  }
  .pc-account__bank {
    text-shadow: 0px 4px 4px #14141459;
    padding-top: 5px;
    font-size: 12px;
    font-weight: 500;
    text-transform: uppercase;
  }
  .pc-currencies {
    position: absolute;
    bottom: 15px;
    left: 15px;
    display: flex;
    column-gap: 4px;
    opacity: 0.75;
  }

}

@media (max-width: $desktop) {
  .pc-account-card {
    width: 322px;

    &.loading {
      margin-left: 12px;
    }
  }
  .pc-account-wrap {
    max-width: 346px;
    padding-left: 12px;
    padding-right: 12px;
  }

}
</style>
